import React from "react";
import { Text, Tooltip } from "@chakra-ui/react";
import { FaArrowsAltH } from "react-icons/all";

import { useConfigurationThemeConsumer } from "ChakraTheme";

import { Icon } from "components/Icon";
import { IconButton } from "components/IconButton";

const LettersSpacingButton = () => {
  const { dispatch, theme } = useConfigurationThemeConsumer();
  const lettersSpacingMessage = "Odstęp między literami";

  return (
    <Tooltip label={lettersSpacingMessage} aria-label={lettersSpacingMessage}>
      <IconButton
        id="letter-spacing-btn"
        aria-label={lettersSpacingMessage}
        background="transparent"
        size="lg"
        icon={
          <Text fontSize="lg">
            <Icon color="black.900" icon={FaArrowsAltH} />A
          </Text>
        }
        onClick={() => {
          if (theme.hugeLettersSpacing) {
            dispatch({ type: "LETTER_SPACING_NORMAL" });
            return;
          }
          dispatch({ type: "LETTER_SPACING_HUGE" });
        }}
      />
    </Tooltip>
  );
};

export { LettersSpacingButton };
